export default {
  all: [],
  needsInsert: [],
  needsUpdate: [],
  needsRemoval: []
};
